const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'fullName',
    },
    {
        title: 'Account Type',
        dataIndex: 'tradingAccountType',
        // sorter: true,
    },
    {
        title: 'Account Name',
        dataIndex: 'planName',
        // sorter: true,
    },
    {
        title: 'Leverage',
        dataIndex: 'leverage',
        // sorter: true,
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
        // sorter: true,
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
        render: defaultRender,
    },
    {
        title: 'Create Date',
        dataIndex: 'createdDate',
        render: defaultRender,
        // sorter: true,
    },
    // {
    //     title: 'Actions',
    //     dataIndex: 'actions',
    // }
];

export default columns;